const CAR_RENTAL = 'car rental';

export default [
  {
    name: 'CAR_RENTAL',
    type: 'bool',
    default: false,
    description: 'Enable/disable car rental',
    category: CAR_RENTAL,
  },
];
